import { Component, Input } from '@angular/core';

@Component({
    selector: 'right-arrow-svg',
    templateUrl: './right-arrow.component.svg',
})
export class RightArrowComponent {
  @Input() fillColor: string ='';

}
